import { render } from "./CoachCoursesView.vue?vue&type=template&id=3edcfded&scoped=true"
import script from "./CoachCoursesView.vue?vue&type=script&lang=js"
export * from "./CoachCoursesView.vue?vue&type=script&lang=js"

import "./CoachCoursesView.vue?vue&type=style&index=0&id=3edcfded&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3edcfded"]])

export default __exports__